import { Box, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Avatar from '../../assets/Images/DefaultAvatar.jpg';
import FilterIcon from '@mui/icons-material/Filter';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import GroupsIcon from '@mui/icons-material/Groups';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Colors from '../../Constant/Colors';
import { UserContextData } from '../../context/AuthContext';
import client from '../../API/client';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

export const RecruiterSearchProfile = () => {
  const { email, id } = useParams();
  const { Recruiter } = useContext(UserContextData);
  const [username, setUsername] = useState('');
  const [r_email, setEmail] = useState('');
  const [fullname, setFullname] = useState('');
  const [companyname, setCompanyname] = useState('');
  const [companyloc, setCompanyloc] = useState('');
  const [followers, setFollowers] = useState([]);
  const [isfollow, setisFollow] = useState(false);
  const [itemData, setItemData] = useState([]);
  const current_user_email = JSON.parse(localStorage.getItem('User_Email'));
  const current_user_id = JSON.parse(localStorage.getItem('user_id'));
  useEffect(() => {
    getData();
    getConnection();
  }, []);
  const getConnection = async () => {
    try {
      await client.get(`/user/connections/followers/${id}`).then((res) => {
        setFollowers(res.data);
        if (res.data.includes(current_user_id)) {
          setisFollow(true);
        } else {
          setisFollow(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getData = async () => {
    try {
      await client
        .get(`/recruiter/search-profile/${email}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          setUsername(res.data.r_username);
          setFullname(res.data.r_fullname);
          setEmail(res.data.r_email);
          setCompanyloc(res.data.company_loc);
          setCompanyname(res.data.company_name);
        });
    } catch (error) {
      console.log('Error', error);
    }

    try {
      await client.get(`/user-profile/posts/${id}`, {}).then((res) => {
        console.log(res.data);
        setItemData(res.data);
      });
    } catch (error) {
      console.log('Error', error);
    }
  };

  const handleFollowUnfollow = async (prop) => {
    console.log(prop);
    if (prop) {
      try {
        await client.delete(`/user/connections/unfollow/${id}/${current_user_id}`).then((res) => {
          console.log(res.data);
          getConnection();
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await client.post(`/user/connections/add-followers/${id}/${current_user_id}`).then((res) => {
          console.log(res.data);
          getConnection();
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div
        style={{
          height: '750px',
          overflow: 'scroll',
          backgroundColor: 'whitesmoke',
        }}>
        <Box m="10px">
          <Paper elevation={3} style={{ borderRadius: 20 }}>
            <div
              style={{
                backgroundColor: Colors.primary,
                height: '120px',
                width: '100%',
                textAlign: 'right',
              }}></div>
            <Row
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                padding: '20px 20px 0px 20px',
              }}>
              <Col style={{ marginLeft: '10px' }}>
                <img
                  src={Avatar}
                  style={{
                    width: 140,
                    height: 140,
                    borderRadius: '0%',
                    objectFit: 'cover',
                    marginTop: -120,
                  }}
                />
                <h4 style={{ marginTop: '10px' }}>{fullname}</h4>
                <div style={{ marginTop: '5px' }}>
                  <span style={{ fontSize: '18px', fontWeight: '500' }}>{username}</span>
                </div>
                <div style={{ marginTop: '5px' }}>
                  <span style={{ fontSize: '18px' }}>Email :- {r_email}</span>
                </div>
              </Col>

              <Col className="profile-connection">
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: 'grey',
                  }}>
                  {itemData.length}
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: Colors.primary,
                  }}>
                  {' '}
                  <FilterIcon style={{ color: Colors.darkpurple }} /> Post
                </div>
              </Col>

              <Col className="profile-connection">
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: 'grey',
                  }}>
                  {followers.length}
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: Colors.primary,
                  }}>
                  {' '}
                  <GroupsIcon style={{ fontSize: '32', color: Colors.darkpurple }} /> Follower
                </div>
              </Col>
            </Row>
            {current_user_email == email ? (
              <Row style={{ marginLeft: '15px', paddingBottom: '15px' }}>
                <Link to={`/recruiter/dashboard/Edit-profile/${Recruiter.recruiter_id}`} style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    sx={{
                      mr: '10px',
                      mt: '10px',
                      color: Colors.primary,
                      backgroundColor: Colors.secondary,
                      letterSpacing: 1,
                      '&:hover': {
                        backgroundColor: 'aquamarine',
                        color: Colors.darkpurple,
                      },
                    }}>
                    <EditTwoToneIcon
                      style={{
                        color: Colors.primary,
                        fontSize: '22px',
                        marginRight: '5px',
                      }}
                    />
                    Edit Profile
                  </Button>
                </Link>
              </Row>
            ) : (
              <Row style={{ marginLeft: '20px', paddingBottom: '20px' }}>
                <Col xs={1}>
                  <Button
                  onClick={() => handleFollowUnfollow(isfollow)}
                    variant="contained"
                    sx={{
                      mr: '10px',
                      mt: '10px',
                      color: Colors.secondary,
                      backgroundColor: Colors.primary,
                      letterSpacing: 1,
                      '&:hover': {
                        backgroundColor: Colors.primary,
                        color: Colors.secondary,
                      },
                    }}>
                    {isfollow ? 'UnFollow' : 'Follow'}
                    
                  </Button>
                </Col>
              </Row>
            )}
          </Paper>

          <Row style={{ marginTop: '20px' }}>
            <Col xs={7}>
              <Paper elevation={4} style={{ padding: '20px', borderRadius: 20 }}>
                <h5 style={{ color: Colors.darkblue }}>Posts</h5>
                <ImageList sx={{ width: '100%', height: 450 }} cols={3} rowHeight={164}>
                  {itemData.map((item) => (
                    <ImageListItem key={item.post_id}>
                      <img src={`${item.img}?w=164&h=164&fit=crop&auto=format`} srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`} alt={item.title} loading="lazy" />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Paper>
            </Col>
            <Col>
              <Row>
                <Paper elevation={4} style={{ padding: '20px', borderRadius: 20 }}>
                  <div>
                    <h5 style={{ color: Colors.darkblue }}>Company Name</h5>
                    <span>{companyname}</span>
                  </div>
                </Paper>
              </Row>
              <Row>
                <Paper
                  elevation={4}
                  style={{
                    padding: '20px',
                    borderRadius: 20,
                    marginTop: '20px',
                  }}>
                  <div>
                    <h5 style={{ color: Colors.darkblue }}>Company Location</h5>
                    <span>{companyloc}</span>
                  </div>
                </Paper>
              </Row>
            </Col>
          </Row>
        </Box>
      </div>
    </>
  );
};
